import { Link, type SxProps, type Theme } from '@mui/material'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import { consumersReturnState } from '@/utils/consumersReturn'
import { useSitesStore } from '@/store/sitesStore'

type MeterLinkProps = {
  meter: string | number
  sx?: SxProps<Theme>
}

// A route change inside the running app. A plain href loads the whole page again.
export default function MeterLink({ meter, sx }: MeterLinkProps) {
  const siteId = useSitesStore(state => state.selectedSite?.siteId)
  const location = useLocation()
  return (
    <Link
      component={RouterLink}
      to={`/${siteId}/consumers/${meter}/details`}
      state={consumersReturnState(location)}
      sx={sx}
    >
      {meter}
    </Link>
  )
}
